import EmpresaService from "../provider/Empresa/EmpresaService";
import { SUCCESS, ERROR, WARNING } from "../common/Util";
import { CHANGE_APP_PROPS, CHANGE_EMPRESA_PROPS } from "./ActionConstants";
import _ from "lodash";

export function actionGetEmpresasList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetEmpresaList(searchText, offset, limit)
			.then(response => {
				dispatch({
					type: CHANGE_EMPRESA_PROPS,
					props: {
						empresasList: response ? response : [],
						total: !_.isEmpty(response) ? response[0].cantidad : 0
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetEmpresaList(searchText, offset, limit) {
	let response = await EmpresaService.getEmpresaList(searchText, offset, limit);
	return response;
}

export function actionCreateEmpresa(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		values = formatObjectToJSON(values);
		asyncCreateEmpresa(values)
			.then(response => {
				if (response.code) callback(ERROR);
				else callback(SUCCESS);
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

function formatObjectToJSON(values) {
	delete values.repassword;
	delete values.terms;
	delete values.currentCuit;
	delete values.currentMail;
	delete values.reemail;
	return values;
}

async function asyncCreateEmpresa(values) {
	let response = await EmpresaService.setEmpresa(values);
	return response;
}

export function actionUpdateEmpresa(empresaId, values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncUpdateEmpresa(empresaId, values)
			.then(response => {
				if (response.code) {
					//TODO
					if (response.code === 50015202) {
						callback(WARNING);
					} else {
						callback(ERROR);
					}
				} else {
					let empresaList = store().empresa.empresasList;
					const empresaIndex = empresaList.findIndex(e => {
						return e.id === response.id;
					});
					empresaList[empresaIndex] = response;
					dispatch({
						type: CHANGE_EMPRESA_PROPS,
						props: {
							empresa: response,
							empresasList: empresaList
						}
					});
					callback(SUCCESS);
				}
			})
			.catch(error => {
				console.log("error", error);
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateEmpresa(empresaId, values) {
	let response = await EmpresaService.updateEmpresa(empresaId, values);
	return response;
}

export function actionGetEmpresaByCuit(cuit, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Buscando"
			}
		});
		asyncGetEmpresaByCuit(cuit)
			.then(response => {
				dispatch({
					type: CHANGE_EMPRESA_PROPS,
					props: {
						empresa: response
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando..."
					}
				});
				if (callback) callback(SUCCESS);
			})
			.catch(() => {
				dispatch({
					type: CHANGE_EMPRESA_PROPS,
					props: {
						empresa: null
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando..."
					}
				});
				if (callback) callback(ERROR);
			});
	};
}

async function asyncGetEmpresaByCuit(cuit) {
	let response = await EmpresaService.getByCuit(cuit);
	return response;
}

export function actionDeleteEmpresa(empresaId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteEmpresa(empresaId)
			.then(response => {
				//TODO
				if (response.code && response.code === 41215203) {
					callback(WARNING);
				} else {
					callback(SUCCESS);
				}
			})
			.catch(error => {
				callback(ERROR);
			});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncDeleteEmpresa(empresaId) {
	//TODO
	let response = await EmpresaService.deleteEmpresa(empresaId);
	return response;
}

export function actionChangeEmpresaProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_EMPRESA_PROPS,
			props: props
		});
	};
}

export async function asyncCheckCuit(cuit) {
	let response = await EmpresaService.checkCuit(cuit);
	return response;
}

export async function asyncCheckMail(cuit) {
	let response = await EmpresaService.checkMail(cuit);
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/EmpresaActions.js